import { Store } from './State';

export let globalEventName = 'scopeEvents';
export let globalStateName = 'scopeState';

export function setGlobalEventName(name: string) {
  (window as any)[name] = (window as any)[globalEventName];
  delete (window as any)[globalEventName];
  globalEventName = name;
}

export function setGlobalStateName(name: string) {
  (window as any)[name] = (window as any)[globalStateName];
  delete (window as any)[globalStateName];
  globalStateName = name;
}

export function exposeScopeState(store: Store) {
  (window as any)[globalStateName] = store.getState();
  store.subscribe(() => {
    (window as any)[globalStateName] = store.getState();
  });
}

export type ScopeEvent = {
  type: string;
};

export type ScopeEventHandler = (event: ScopeEvent) => any;

const eventHandlers: { [eventName: string]: ScopeEventHandler[] } = {};

export function onScopeEvent(eventName: string, handler: ScopeEventHandler) {
  if (!eventHandlers[eventName]) {
    eventHandlers[eventName] = [];
  }
  eventHandlers[eventName].push(handler);
  return () => {
    const index = eventHandlers[eventName].indexOf(handler);
    if (index !== -1) {
      eventHandlers[eventName].splice(index, 1);
    }
  };
}

export function dispatchScopeEvent(event: ScopeEvent) {
  if (eventHandlers[event.type]) {
    eventHandlers[event.type].forEach(handler => {
      try {
        handler(event);
      } catch (e) {
        logError(e);
      }
    });
  }
}

function logError(e: Error) {
  if (self.console && self.console.error) {
    self.console.error(e);
  }
}

(window as any)[globalEventName] = {
  on: onScopeEvent,
  dispatch: dispatchScopeEvent,
};
